import { interpolateRound } from 'd3-interpolate';
export default function applyRound(config, scale) {
  if ('round' in config && config.round === true) {
    const roundableScale = scale;

    if ('round' in roundableScale) {
      roundableScale.round(config.round);
    } else {
      roundableScale.interpolate(interpolateRound);
    }
  }
}